import api from './Api'

const route = '/notifications'

export default {
  get: params => api().get(`${route}`, { params: { ...params, expand: 'vehicle,user,movement' } }), // Aquí se puede ver que se está haciendo una petición GET a la ruta /notificacions
  read: (payload) => api().get(`${route}/${payload.id}/read`),
  unread: (payload) => api().post(`${route}/${payload.id}/unread`),
  readAll: () => api().get(`${route}/read/all`),
  unreadCount: () => api().get(`${route}/unread-count`),
  delete: (payload) => api().delete(`${route}/${payload}`),
  view: params => api().get(`${route}/${params.id}`, { params })
}
